import { CalendarClock } from "lucide-react";
import type { Session } from "@/features/auth/api/session.api";
import { expiryPhrase, expiryWarning } from "./subscription-notice";

/**
 * "Aboneliğiniz 3 gün sonra sona eriyor."
 *
 * WHY A COUNTDOWN AND NOT JUST THE 402. The refusal arrives the moment the subscription has
 * already lapsed, which is the moment it is too late to do anything about it quietly. Two weeks
 * of notice turns an outage into a commercial conversation.
 *
 * NOT DISMISSIBLE, and it stays until the date passes or the subscription is renewed. A banner
 * somebody can close is a banner that is closed on the first day and never seen again — and the
 * day that matters is the last one.
 *
 * It renders nothing at all for a perpetual package, for anything further out than the
 * threshold, and for a customer already blocked (they get the blocking screen instead, and a
 * countdown beside it would restate the same thing more weakly).
 */
export function SubscriptionExpiryBanner({ session }: { session: Session }) {
  const warning = expiryWarning(session);
  if (!warning) return null;

  // Under three days it stops being an FYI. Same banner, louder colours — a second component
  // would be two places to edit the wording.
  const urgent = warning.days <= 3;

  return (
    <div
      role="status"
      className={`flex items-center gap-2 px-4 py-1.5 text-xs ${
        urgent
          ? "bg-danger-bg text-danger"
          : "bg-warning-bg text-warning-ink"
      }`}
    >
      <CalendarClock aria-hidden className="size-3.5 shrink-0" />
      <span>
        Aboneliğiniz <strong>{expiryPhrase(warning.days)}</strong> sona eriyor. Kesintisiz devam
        etmek için ALTEK ile iletişime geçin.
      </span>
    </div>
  );
}
